import React from "react";

const HierarchyMyDataCustomCell = ({ e, rowTemplate }) => {
  const { dataItem, children } = e;

  return (
    <td {...e.tdProps} colSpan={1}>
      {dataItem.is_parent || rowTemplate ? children : <></>}
    </td>
  );
};

export default HierarchyMyDataCustomCell;
